module.exports = __webpack_public_path__ + "img/credit-card-new.21139066.png";